import React from "react";
import "./style.css";
import FounderImg from "../../assets/img/banner/WhatsApp Image 2025-06-12 at 16.49.22_fdfb13ef.jpg";

const Founder = () => {
  React.useEffect(() => {
    document.body.style.backgroundColor = "#FCFCFC";
    return () => {
      document.body.style.backgroundColor = "";
    };
  }, []);

  return (
    <>
      <div
        className="row justify-content-center mb-4"
        style={{ marginTop: "5%" }}
      >
        <div className="col-12 text-center">
          <div className="section_title">
            <p className="section_subtitle">OUR TEAM</p>
            <h2 className="section_heading">Meet Our Founder</h2>
          </div>
        </div>
      </div>
      <div className="egpersona2a__wrapper">
        <div className="egpersona2a__ovalimagewrapper">
          <img
            src={FounderImg}
            alt="Founder"
            className="egpersona2a__ovalimage"
          />
        </div>
        <div className="egpersona2a__contentwrapper">
          <div
            className="egpersona2a__paragraph"
            // style={{ padding: "10%", textAlign: "justify" }}
          >
            <p>
              Samantha’s heart beats deeply for babies just as it does for
              marriage. From a young age, she was exposed to the tragic stories
              of school-aged girls who died from unsafe abortions and newborns
              who were abandoned, sometimes found lifeless, and other times
              crying in agony for a mother who would never return. Each
              encounter broke her heart. As a child, all she could do was weep.
            </p>
            <p>
              Samantha is married to her husband, who supports her
              wholeheartedly, and they are blessed with beautiful kids. She is
              the founder of Cradle Care Foundation for Vulnerable Women and
              Children, a nonprofit organization that embraces single and
              pregnant moms and seeks to support them emotionally, spiritually,
              and practically in their time of need.
            </p>
            <p>
              As she grew older, Samantha began envisioning a system that would
              allow mothers facing critical situations to safely give up their
              babies to loving homes. However, in Nigeria, where she was born
              and raised; the challenges of safety, identity protection, and
              societal acceptance made the idea nearly impossible to implement.
              Yet her passion to help never faded; instead, it fueled her
              determination to return to the drawing board and explore other
              meaningful solutions to reduce abortion and child abandonment.
            </p>
            <p>
              Through research and observation, she discovered that poverty and
              the stigma of young, unplanned pregnancies ranked high among the
              root causes. In Nigerian culture, where hardship is widespread and
              societal shame runs deep, teenage pregnancies often result in the
              girl being disowned by her parents or abandoned by the child’s
              father. This leaves the young girl in despair, faced with the
              crushing decision to abort, abandon her child after birth, or
              struggle to raise the child alone.
            </p>
            <p>
              Though Samantha knows she cannot completely solve these problems,
              her mission is clear: to ensure that no woman walks through this
              journey feeling unloved or alone, and that every child is wanted.
              She meets these women at their most vulnerable, offering practical
              help, emotional support, and spiritual encouragement.
            </p>
            <p>
              One powerful way she has chosen to do this is by organizing baby
              showers for expectant mothers in desperate need; giving them a
              sense of dignity, joy, and hope. Through these gatherings,
              Samantha not only celebrates motherhood but also creates a
              supportive community for women who need it most.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Founder;
